import { render, staticRenderFns } from "./newsMove.vue?vue&type=template&id=625767df&scoped=true"
import script from "./newsMove.vue?vue&type=script&lang=js"
export * from "./newsMove.vue?vue&type=script&lang=js"
import style0 from "./newsMove.vue?vue&type=style&index=0&id=625767df&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "625767df",
  null
  
)

export default component.exports